import React from 'react'
import { Redirect } from 'react-router'
import HeaderContent from '../components/HeaderContent'
import EnabledButtonSave from '../components/EnabledButtonSave'
import ButtonBack from '../components/ButtonBack'
import t from 'tcomb-form'
import transform from 'tcomb-json-schema'
import { getTemplates } from '../components/Templates/templates'
import '../assets/style.css'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import uuidv4 from 'uuid/v4'
import config from '../config'

const templates = getTemplates()
const Form = t.form.Form

const options = {
  fields: {
    date_time: {
      label: 'Date de la transaction',
      template: templates['dateTimePicker']
    },
    operation: {
      label: 'Type de transaction',
      template: templates['belongsTo']
    },
    card: {
      label: 'Numéro de carte',
      template: templates['belongsTo']
    },
    vehicle_number: {
      label: "Numéro d'immatriculation du véhicule",
      template: templates['text']
    },
    sale_point: {
      label: 'Nom de la station-service',
      template: templates['text']
    },
    service: {
      label: 'Produit/Service',
      template: templates['belongsTo']
    },
    quantity: {
      label: 'Quantité',
      template: templates['number']
    },
    unit_price_pdv: {
      label: 'Prix du terminal',
      template: templates['number']
    },
    discount: {
      label: 'Taux de remise',
      template: templates['number']
    },
    unit_price_client: {
      label: 'Prix client',
      template: templates['number']
    },
    cost_client: {
      label: 'Montant du client',
      template: templates['number']
    },
    bill_number: {
      label: 'Numéro de facture',
      template: templates['text']
    },
    bill_date_time: {
      label: 'Date de la facture',
      template: templates['dateTimePicker']
    },
    previous_odometer_reading: {
      label: 'Précédent relevé du compteur kilométrique',
      template: templates['number']
    },
    indication: {
      label: 'Relevé actuel du compteur kilométrique',
      template: templates['number']
    },
    mileage: {
      label: 'Distance',
      template: templates['number']
    },
    liter_for_hundred: {
      label: 'Consommation Litres / 100km',
      template: templates['number']
    },
    cost_for_hundred: {
      label: 'Cout/km',
      template: templates['number']
    },
    label: {
      label: 'Numéro du Tag chauffeur',
      template: templates['number']
    },
    driver_name: {
      label: 'Nom du chauffeur sur le Tag chauffeur',
      template: templates['text']
    }
  }
}

class AddTicket extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: null,
      reference: 'TICKET',
      toTickets: false,
      disabled: false
    }
  }

  UNSAFE_componentWillMount () {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        if (self.props.location.state && self.props.location.state.dataOfForm) {
          fetch(
            `${config.couchdb_jsonapi}schema`,
            { headers: { 'Access-Control-Allow-Origin': '*' } }
          )
            .then(response => response.json())
            .then((data) => {
              self.setState({
                data: data.schema.FUEL_SENSOR_TICKET,
                value: self.props.location.state.dataOfForm.attributes
              })
            })
            .catch(error => { console.log(error) })
        } else {
          fetch(
            `${config.couchdb_jsonapi}schema`,
            { headers: { 'Access-Control-Allow-Origin': '*' } }
          )
            .then(response => response.json())
            .then((data) => {
              self.setState({
                data: data.schema.FUEL_SENSOR_TICKET
              })
            })
            .catch(error => { console.log(error) })
        }
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  onSubmit (evt) {
    const self = this
    evt.preventDefault()
    const value = this.refs[this.state.reference].getValue()
    if (value) {
      let newValue = Object.assign({}, value)
      newValue['vehicle_number'] = newValue['vehicle_number'].replace(/\s/g, '').toUpperCase()
      self.setState({
        disabled: true
      })
      let attributes = Object.assign(
        {
          validatedAt: new Date().toJSON(),
          has_event: true,
          checked: false,
          state: ''
        },
        newValue)
      let body = {
        data: {
          type: 'FUEL_SENSOR_TICKET',
          attributes: attributes
        }
      }
      var token = localStorage.getItem('token')
      getUserInfo(token)
        .then(response => response.json())
        .then(function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token'))
          }
          if (self.props.location.state && self.props.location.state.dataOfForm) {
            fetch(`${config.couchdb_jsonapi}fuel_sensor_ticket/${self.props.location.state.dataOfForm.id}`, {
              method: 'PUT',
              body: JSON.stringify(body),
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/vnd.api+json'
              }
            }).then(response => {
              response.json()
              self.setState({
                toTickets: true
              })
            }).catch(error => console.log(error))
          } else {
            fetch(`${config.couchdb_jsonapi}fuel_sensor_ticket/${uuidv4()}`, {
              method: 'PUT',
              body: JSON.stringify(body),
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/vnd.api+json'
              }
            }).then(response => {
              response.json()
              self.setState({
                toTickets: true
              })
            }).catch(error => console.log(error))
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  onChange (value) {
    console.log("Value: ",value)
    this.setState({
      value: value
    })
  }

  render () {
    const self = this
    if (!this.state.data) {
      return null
    }
    if (this.state.toTickets === true) {
      return <Redirect to={`/${localStorage.getItem('endpoint')}/tickets`} />
    }
    return (
      <div>
        <div style={styles.container}>
          <div style={styles.header}>
            <HeaderContent
              title={this.props.location.state && this.props.location.state.title ? this.props.location.state.title : 'Ajouter un ticket'}
            />
          </div>
          <div style={styles.parentContent}>
            <div style={styles.content}>
              <form
                onSubmit={(e) => self.onSubmit(e)}>
                <div style={styles.fieldContent}>
                  <Form
                    ref={this.state.reference}
                    type={transform(this.state.data)}
                    options={options}
                    value={this.state.value}
                    onChange={(value) => this.onChange(value)}
                  />
                  <div className='form-group'>
                    <EnabledButtonSave
                      label='OK'
                      type='submit'
                      disabled={this.state.disabled}
                    />
                    <ButtonBack
                      label='ANNULER'
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    backgroundColor: '#15191C',
    height: '100vh',
    paddingTop: '12px'
  },
  header: {
    width: '334px',
    margin: 'auto'
  },
  parentContent: {
    width: '100%',
    overflow: 'hidden'
  },
  content: {
    width: '100%',
    height: '80vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: '17px'
  },
  fieldContent: {
    height: '80vh',
    width: '334px',
    margin: 'auto'
  }
}

export default AddTicket
